import request from "@/utils/request";
const reportBaseurl = `${process.env.VUE_APP_REPORTING_SERVICE}/api/v1/report`;
export default {
  v2TransactionReport(params) {
    return request({
      url: `${reportBaseurl}/get-transaction-report`,
      method: "GET",
      params: params,
    });
  },
  getrbaReport(params) {
    return request({
      url: `${reportBaseurl}/get-rba-report`,
      method: "GET",
      params: params,
    });
  },
  gettxnAnalysisReport(params) {
    return request({
      url: `${reportBaseurl}/transaction-analysis-report`,
      method: "GET",
      params: params,
    });
  },
  getrspReport(params) {
    return request({
      url: `${reportBaseurl}/get-rsp-report`,
      method: "GET",
      params: params,
    });
  },
  getSOAReport(params) {
    return request({
      url: `${reportBaseurl}/get-soa-report`,
      method: "GET",
      params: params,
    });
  },
};
